import { withStyles } from '@material-ui/core';
import RestrictedPage from './Restricted';
import styles from './Restricted.styles';

export default withStyles(styles)(RestrictedPage);
